import { Chip } from "@mui/material";
import { ShipmentMethodEnum } from "../enums/shipmentMethod";

interface Props {
    value: ShipmentMethodEnum
}

const ShipmentMethodChip = ({ value }: Props) => {
    return <Chip
        style={{
            backgroundColor: value===ShipmentMethodEnum.DELIVERY ? '#36B37E29' : '#FF563029',
            color:  value===ShipmentMethodEnum.DELIVERY ? '#1B806A' : '#B71D18',
            borderRadius: '5px'
        }}
        label={value}
    />
}
export default ShipmentMethodChip;